const MY_ACCOUNT = 'Click My Account';
const PREFERENCES = 'Click Preferences';
const LOG_OUT = 'Click Log Out';
const SWITCH_COMPANY = 'Switch Company';
const LOGIN_TO_ANOTHER_COMPANY = 'Click Login to Another Company';

const companyNavMenuAnalyticConstants = {
  MY_ACCOUNT,
  PREFERENCES,
  LOG_OUT,
  SWITCH_COMPANY,
  LOGIN_TO_ANOTHER_COMPANY,
};

export default companyNavMenuAnalyticConstants;
